module.exports = __webpack_public_path__ + "img/alena.d898fd79.png";